exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-layout[data-v-449cb694] {\r\n  border-left: 1px solid #DCDFE6;\r\n  border-top: 1px solid #DCDFE6;\n}\n.table-cell[data-v-449cb694] {\r\n  height: 60px;\r\n  line-height: 40px;\r\n  border-right: 1px solid #DCDFE6;\r\n  border-bottom: 1px solid #DCDFE6;\r\n  padding: 10px;\r\n  font-size: 14px;\r\n  color: #606266;\r\n  text-align: center;\r\n  overflow: hidden;\n}\n.table-cell-title[data-v-449cb694] {\r\n  border-right: 1px solid #DCDFE6;\r\n  border-bottom: 1px solid #DCDFE6;\r\n  padding: 10px;\r\n  background: #f3f5f9;\r\n  text-align: center;\r\n  font-size: 14px;\r\n  color: #303133;\n}\r\n\r\n\r\n", ""]);

// exports
